import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import usbService from "../js/usb-services.js";
import commonAPIService from "@/components/common/js/common-api-service.js";
import PrinterDetails from "../../common/printer-details";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      soKey: 0,
      lineData: [],
      headerData: [],
      debouncedGetPartList: [],
      isFormValid: false,
      scanPartNum: "",
      showPartNumDetails: false,
      partResultList: [],
      configurSourcingDialog: false,
      customerId1: "",
      customerId2: "",
      targetInTransitLPN: "",
      disableTargetLPN: false,
      unitID: "",
      disableUnitId: false,
      showUnitID: false,
      showBinLPN: false,
      sourceBinLPN: "",
      disableSourceBinLPN: true,
      showQuantity: false,
      quantity: 0,
      disableQuantity: true,
      showSubmit: false,
      disableSubmitPick: true,
      partNumber: "",
      lineId: 0,
      sourceOptionData: [],
      sourceHeaderData: [],
      sourceBinData: [],
      serialsDialog: false,
      serialsData: [],
      selectedSerialsBin: "",
      selectedSerialsLPN: "",
      copiedSnackbar: false,
      dropOffLPNDialog: false,
      userAssignedLPN: "",
      stagingLocationLPN: "",
      dropLPN: false,
      availableQty: 0,
      lpnKey: "",
      lineKey: "",
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character", (v) => !!v || "Field is required"],
      lpnRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",
      ],
      headersSource: [
        { text: "Line Number", value: "line_num", class: "primary customwhite--text", align: "start", sortable: false, width: "10%" },
        { text: "Workflow", value: "workflow", class: "primary customwhite--text", sortable: false, width: "10%" },
        { text: "Part Number", value: "part_num_desc", class: "primary customwhite--text", sortable: false, width: "25%" },
        { text: "Order Quantity", value: "order_qty", class: "primary customwhite--text", sortable: false, width: "10%" },
        { text: "Sourced Quantity", value: "sourced_qty", class: "primary customwhite--text", sortable: false, width: "10%" },
        { text: "Assigned To", value: "assigned_to", class: "primary customwhite--text", sortable: false, width: "15%" },
        { text: "Source", value: "Source", class: "primary customwhite--text", sortable: false, width: "10%" },
        { text: "Exit Line", value: "Exit", class: "primary customwhite--text", sortable: false, width: "10%" },
      ],
      sourceLineHeaders: [
        { text: "Line#", value: "line_num", class: "primary customwhite--text", align: "start", sortable: false },
        { text: "Part", value: "part_num", class: "primary customwhite--text", sortable: false },
        { text: "Warehouse", value: "warehouse", class: "primary customwhite--text", sortable: false },
        { text: "Order Quantity", value: "ordered_qty", class: "primary customwhite--text", sortable: false },
        { text: "Sourced", value: "sourced_qty", class: "primary customwhite--text", sortable: false },
      ],
      sourceBinHeaders: [
        { text: "Bin", value: "bin", class: "primary customwhite--text", sortable: false },
        { text: "LPN", value: "lpn", class: "primary customwhite--text", sortable: false },
        { text: "Quantity", value: "qty", class: "primary customwhite--text", sortable: false },
        { text: "Avg. Age(Days)", value: "avg_age", class: "primary customwhite--text", sortable: false },
        { text: "Action", value: "action", class: "primary customwhite--text", sortable: false },
      ],
      serialsHeaders: [
        { text: "Identifier", value: "identifier", class: "primary customwhite--text" },
        { text: "Action", value: "action", class: "primary customwhite--text", sortable: false, align: "end", width: "48px" },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (this.$route.params.soKey !== undefined) {
      this.soKey = atob(this.$route.params.soKey);
      let exitLine = false;
      this.sourceConfigLoadOrder(exitLine);
      this.dropOffCheckUser();
    } else {
      this.$router.push(`/configuration-sourcing`);
    }
    this.debouncedGetPartList = Utility.debounce(this.getPartSourceData, 500);
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.lineData = [];
      this.headerData = [];
      this.scanPartNum = "";
      this.showPartNumDetails = false;
      this.partResultList = [];
      this.configurSourcingDialog = false;
      this.targetInTransitLPN = "";
      this.disableTargetLPN = false;
      this.unitID = "";
      this.disableUnitId = false;
      this.showUnitID = false;
      this.showBinLPN = false;
      this.sourceBinLPN = "";
      this.disableSourceBinLPN = true;
      this.showQuantity = false;
      this.quantity = 0;
      this.disableQuantity = true;
      this.showSubmit = false;
      this.disableSubmitPick = true;
      this.partNumber = "";
      this.lineId = 0;
      this.sourceOptionData = [];
      this.sourceHeaderData = [];
      this.sourceBinData = [];
      this.serialsDialog = false;
      this.serialsData = [];
      this.selectedSerialsBin = "";
      this.selectedSerialsLPN = "";
      this.copiedSnackbar = false;
      this.dropOffLPNDialog = false;
      this.userAssignedLPN = "";
      this.stagingLocationLPN = "";
      this.dropLPN = false;
      this.availableQty = 0;
      let exitLine = false;
      this.sourceConfigLoadOrder(exitLine);
      this.dropOffCheckUser();
    },
    async sourceConfigLoadOrder(exitLine) {
      let data = await usbService.sourceConfigLoadOrder("get", this.userId, this.soKey);
      if (data !== undefined) {
        const newArr = data?.header?.map((obj) => {
          return {
            ...obj,
            stage_date: obj?.stage_date !== undefined ? Utility.displayDateFormat(obj?.stage_date) : "",
            allocated_date: obj?.allocated_date !== undefined ? Utility.displayDateFormat(obj?.allocated_date) : "",
          };
        });
        this.lineData = data?.lines;
        if (this.lineData?.length == 1 && !exitLine) {
          this.getSourceData(this.lineData[0]);
        }
        this.headerData = newArr;
      }
    },
    async dropOffCheckUser() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_validate_dropoff_check?user_key=${this.userId}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (response.data.body.message !== "" && response.data.body.message !== undefined) {
              this.userAssignedLPN = response.data.body.message;
              this.lpnKey = this.userAssignedLPN.replace(/-/g, "");
              this.dropLPN = true;
            } else {
              this.dropLPN = false;
              this.userAssignedLPN = "";
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            this.dropLPN = false;
            this.userAssignedLPN = "";
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          }
        })
        .catch((error) => {
          this.dropLPN = false;
          this.userAssignedLPN = "";
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: false,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Close Drop Off LPN Dialog
    closeDropLPNDialog() {
      this.dropOffLPNDialog = false;
      this.stagingLocationLPN = "";
      this.$refs.stagingLocationCheckForm.resetValidation();
    },
    //Drop Off LPN
    lpnDropOff() {
      if (this.$refs.stagingLocationCheckForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .get(`wc/source_config_validate_dropoff_lpn?user_key=${this.userId}&bin=${this.stagingLocationLPN}`)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.getSourceConfigLineKeys();
              this.closeDropLPNDialog();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              this.stagingLocationLPN = "";
              this.$refs.stagingLocationCheckForm.resetValidation();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            this.stagingLocationLPN = "";
            this.$refs.stagingLocationCheckForm.resetValidation();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Get Source Configuration Line Keys
    getSourceConfigLineKeys() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("usb/sourcing_configuration_line_keys?userid=" + this.userId + "&lpn_key=" + this.lpnKey)
        .then((response) => {
          if (response.status == 200) {
            let responseData = JSON.parse(response.data.body.message);
            this.lineKey = responseData[0].sot_line_key;
            this.getSourceConfigBTOPrint();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Get Source Configuration BTO Print
    getSourceConfigBTOPrint() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("usb/sourcing_configuration_kits_bto_print_html?user_id=" + this.userId + "&line_id=" + this.lineKey)
        .then((response) => {
          if (response.status == 200) {
            if (
              EncryptUtility.localStorageDecrypt("defaultName") !== undefined &&
              EncryptUtility.localStorageDecrypt("defaultName") !== null &&
              EncryptUtility.localStorageDecrypt("defaultName") !== ""
            ) {
              Utility.printZPLPDF(response.data.body.message, EncryptUtility.localStorageDecrypt("defaultName"));
            }
            this.resetFunction();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Part number search event
    async searchPartNum() {
      if (this.scanPartNum?.length > 2) {
        this.debouncedGetPartList();
      }
    },
    //Source button click event
    async getPartSourceData() {
      if (this.scanPartNum !== null && this.scanPartNum !== "") {
        let obj = {
          user_id: parseInt(this.userId),
          order_key: parseInt(this.soKey),
          part_num: this.scanPartNum,
          line_id: 0,
        };
        let showMessage = false;
        let data = await usbService.sourceConfigFindbyPart("post", obj, showMessage);
        if (data.message !== "NA") {
          this.showPartNumDetails = true;
          this.partResultList = data?.header;
        }
      }
    },
    //Part Details
    async partDetails(item) {
      this.partNumber = item.part_num;
      this.lineId = parseInt(item.line_id);
      let obj = {
        user_id: parseInt(this.userId),
        order_key: parseInt(this.soKey),
        part_num: item.part_num,
        line_id: parseInt(item.line_id),
      };
      let showMessage = false;
      let data = await usbService.sourceConfigFindbyPart("post", obj, showMessage);
      if (data.message !== "NA") {
        this.sourceOptionData = data?.options;
        this.sourceHeaderData = data?.header;
        this.sourceBinData = data?.bins;
        const splitStrings = this.sourceHeaderData[0]?.customer_id.split(" ");
        this.customerId1 = splitStrings[0];
        this.customerId2 = splitStrings[1];
        if (this.sourceBinData !== undefined && this.sourceBinData !== null) {
          this.sourceBinData = this.sourceBinData?.map((item) => ({
            ...item,
            active: false,
          }));
        }
        this.configurSourcingDialog = true;
        this.targetInTransitLPN = "";
        this.disableTargetLPN = false;
        this.unitID = "";
        this.disableUnitId = false;
        this.showUnitID = false;
        this.showBinLPN = false;
        this.sourceBinLPN = "";
        this.disableSourceBinLPN = true;
        this.showQuantity = false;
        this.quantity = 0;
        this.disableQuantity = true;
        this.showSubmit = false;
        this.disableSubmitPick = true;
        this.partResultList = [];
        this.showPartNumDetails = false;
        this.scanPartNum = "";
        if (this.userAssignedLPN !== "" && this.userAssignedLPN !== null) {
          this.targetInTransitLPN = this.userAssignedLPN;
          this.validateTargetLPN();
        }
      }
    },
    //Clearing part search results
    clearPartShip() {
      this.showPartDetails = false;
      this.scanPartNum = "";
      this.partResultList = [];
    },
    //Source button click event in the data table
    async getSourceData(item) {
      this.partNumber = item.part_num;
      this.lineId = parseInt(item.line_id);
      let obj = {
        user_id: parseInt(this.userId),
        order_key: parseInt(this.soKey),
        part_num: item.part_num,
        line_id: parseInt(item.line_id),
      };
      let showMessage = false;
      let data = await usbService.sourceConfigFindbyPart("post", obj, showMessage);
      if (data.message !== "NA") {
        this.sourceOptionData = data?.options;
        this.sourceHeaderData = data?.header;
        this.sourceBinData = data?.bins;
        const splitStrings = this.sourceHeaderData[0]?.customer_id.split(" ");
        this.customerId1 = splitStrings[0];
        this.customerId2 = splitStrings[1];
        if (this.sourceBinData !== undefined && this.sourceBinData !== null) {
          this.sourceBinData = this.sourceBinData?.map((item) => ({
            ...item,
            active: false,
          }));
        }
        this.configurSourcingDialog = true;
        this.targetInTransitLPN = "";
        this.disableTargetLPN = false;
        this.unitID = "";
        this.disableUnitId = false;
        this.showUnitID = false;
        this.showBinLPN = false;
        this.sourceBinLPN = "";
        this.disableSourceBinLPN = true;
        this.showQuantity = false;
        this.quantity = 0;
        this.disableQuantity = true;
        this.showSubmit = false;
        this.disableSubmitPick = true;
        if (this.userAssignedLPN !== "" && this.userAssignedLPN !== null) {
          this.targetInTransitLPN = this.userAssignedLPN;
          this.validateTargetLPN();
        }
      }
    },
    //Get next available LPN number
    async getLPNNumber() {
      let lpnData = await commonAPIService.getNextAvailableLPN("get", this.userId);
      if (lpnData.message !== "NA") {
        this.targetInTransitLPN = lpnData[0].lpn;
        this.validateTargetLPN();
      }
    },
    //Exit button click event in the data table
    exitSourcing(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_exit?user_id=${this.userId}&line_id=${item.line_id}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            let exitLine = true;
            this.sourceConfigLoadOrder(exitLine);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //To check whether input value is number or not
    isNumber(event) {
      let value = Utility.isNumber(event);
      return value;
    },
    //to check if its a number with hyphen of not
    lpnNumFormat(event, num) {
      this.targetInTransitLPN = Utility.formatLPNNumber(event, num);
    },
    //Close dialog in the popup
    closeDialog() {
      this.targetInTransitLPN = "";
      this.disableTargetLPN = false;
      this.unitID = "";
      this.disableUnitId = false;
      this.showUnitID = false;
      this.showBinLPN = false;
      this.sourceBinLPN = "";
      this.disableSourceBinLPN = true;
      this.showQuantity = false;
      this.quantity = 0;
      this.disableQuantity = true;
      this.showSubmit = false;
      this.disableSubmitPick = true;
      this.configurSourcingDialog = false;
      this.sourceOptionData = [];
      this.sourceHeaderData = [];
      this.sourceBinData = [];
      let exitLine = true;
      this.sourceConfigLoadOrder(exitLine);
    },
    //Refresh in Picking Queue popup
    async refreshSourceDetails() {
      this.targetInTransitLPN = "";
      this.disableTargetLPN = false;
      this.unitID = "";
      this.disableUnitId = true;
      this.sourceBinLPN = "";
      this.disableSourceBinLPN = true;
      this.disableSourceLPN = true;
      this.quantity = 0;
      this.disableQuantity = true;
      this.disableSubmitPick = true;
      const sourceData = this.sourceBinData.find((element) => element.active == true);
      if (sourceData) {
        sourceData.active = false;
      }
      this.showUnitID = false;
      this.showBinLPN = false;
      this.showQuantity = false;
      this.showSubmit = false;
      this.$refs.lineNumForm.resetValidation();
      this.$refs.targetLPNForm.resetValidation();
      let obj = {
        user_id: parseInt(this.userId),
        order_key: parseInt(this.soKey),
        part_num: this.partNumber,
        line_id: parseInt(this.lineId),
      };
      let showMessage = false;
      let data = await usbService.sourceConfigFindbyPart("post", obj, showMessage);
      if (data.message !== "NA") {
        this.sourceOptionData = data?.options;
        this.sourceHeaderData = data?.header;
        this.sourceBinData = data?.bins;
        const splitStrings = this.sourceHeaderData[0]?.customer_id.split(" ");
        this.customerId1 = splitStrings[0];
        this.customerId2 = splitStrings[1];
        if (this.sourceBinData !== undefined && this.sourceBinData !== null) {
          this.sourceBinData = this.sourceBinData?.map((item) => ({
            ...item,
            active: false,
          }));
        }
      }
    },
    //Exit Line
    async exitLine(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`wc/source_config_exit?user_id=${this.userId}&line_id=${item.line_id}`)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.configurSourcingDialog = false;
            let exitLine = true;
            this.sourceConfigLoadOrder(exitLine);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Validate In Transit LPN
    async validateTargetLPN() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("wc/source_config_validate_lpn?userID=" + this.userId + "&lpn=" + this.targetInTransitLPN)
        .then((response) => {
          if (response.status == 200) {
            this.showUnitID = true;
            this.unitID = "";
            this.disableUnitId = false;
            this.disableTargetLPN = true;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Validate Unit Identifier
    async validateUnitID() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("wc/source_config_validate_unitid?userID=" + this.userId + "&unit=" + this.unitID)
        .then((response) => {
          if (response.status == 200) {
            let data = JSON.parse(response.data.body.message);
            if (data[0]?.enable_bin) {
              this.showBinLPN = true;
              this.showQuantity = false;
              this.showSubmit = false;
              this.quantity = 0;
              this.sourceBinLPN = "";
              this.disableSourceBinLPN = false;
              this.disableUnitId = true;
              this.disableQuantity = true;
              this.disableSubmitPick = true;
            } else if (data[0]?.enable_submit) {
              this.showBinLPN = false;
              this.showQuantity = false;
              this.showSubmit = false;
              this.quantity = 1;
              this.sourceBinLPN = "";
              this.disableSourceBinLPN = true;
              this.disableUnitId = true;
              this.disableQuantity = true;
              this.disableSubmitPick = true;
              this.submitSourcing();
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Validate Source Bin LPN
    async validateSourceBinLPN() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("wc/source_config_validate_source_binlpn?userID=" + this.userId + "&bin=" + this.sourceBinLPN)
        .then((response) => {
          if (response.status == 200) {
            let data = JSON.parse(response.data.body.message);
            this.showQuantity = true;
            this.quantity = 0;
            this.disableQuantity = false;
            this.disableSourceBinLPN = true;
            this.showQuantity = data[0]?.enable_qty;
            this.availableQty = data[0]?.avail_qty;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    async getSerialsByLPNBin(item) {
      this.selectedSerialsBin = item?.bin || "";
      this.selectedSerialsLPN = item?.lpn || "";
      let obj = {
        user_id: parseInt(this.userId),
        order_key: parseInt(this.soKey),
        line_id: parseInt(this.lineId || this.sourceHeaderData[0]?.line_id),
        lpn: item?.lpn || "",
        bin: item?.bin || "",
      };
      let serialsData = await usbService.ConfigurationSourcingGetSerialsByLPNBin(obj);
      console.debug("ConfigurationSourcingGetSerialsByLPNBin parsed data", serialsData);
      const serialsList = Array.isArray(serialsData)
        ? serialsData
        : Array.isArray(serialsData?.Result)
        ? serialsData.Result
        : Array.isArray(serialsData?.result)
        ? serialsData.result
        : Array.isArray(serialsData?.data)
        ? serialsData.data
        : [];
      if (serialsData.message !== "NA" && serialsList.length > 0) {
        this.serialsData = serialsList;
        this.serialsDialog = true;
      } else {
        this.serialsData = [];
        let Alert = {
          type: "error",
          isShow: true,
          message: "No identifiers found",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },
    isSerializedItem(item) {
      return [
        this.sourceHeaderData[0],
        this.sourceOptionData[0],
        item,
      ].some((data) => this.isSerializedValue(data?.IsSerialized ?? data?.isSerialized ?? data?.is_serialized ?? data?.serialized));
    },
    isSerializedValue(serialized) {
      return serialized === true || serialized === 1 || serialized === "1" || String(serialized).toLowerCase() === "true";
    },
    closeSerialsDialog() {
      this.serialsDialog = false;
      this.serialsData = [];
      this.selectedSerialsBin = "";
      this.selectedSerialsLPN = "";
    },
    getIdentifierValue(item) {
      return item?.identifier || item?.Identifier || "";
    },
    async copyIdentifier(item) {
      const identifier = this.getIdentifierValue(item);
      if (!identifier) return;
      await navigator.clipboard.writeText(identifier);
      this.closeSerialsDialog();
      this.unitID = "";
      this.$nextTick(() => {
        this.unitID = identifier;
        this.$refs.refUnitID?.focus();
      });
      this.copiedSnackbar = true;
    },
    //Quantity validation
    validateQuantity() {
      if (this.quantity !== null && this.quantity !== "") {
        this.quantity = parseInt(this.quantity);
        if (this.quantity !== 0) {
          if (this.availableQty >= this.quantity) {
            this.disableQuantity = true;
            this.disableSubmitPick = false;
            this.showSubmit = true;
          } else {
            this.quantity = 0;
            this.showSubmit = false;
            this.disableSubmitPick = true;
            let Alert = {
              type: "error",
              isShow: true,
              message: "Available quantity is " + this.availableQty,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        } else {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Quantity should be greater than 0",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      }
    },
    //Source Sourcing Submit
    submitSourcing() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        userid: parseInt(this.userId),
        to_lpn: this.targetInTransitLPN,
        unit_identifier: this.unitID,
      };
      this.axios
        .post("wc/source_config_submit", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let data = JSON.parse(response.data.body.message);
            if (data[0]?.note !== "") {
              let Alert = {
                type: "success",
                isShow: true,
                message: data[0].note,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            if (data[0]?.order_openqty == 0) {
              this.$router.push(`/configuration-sourcing`);
            } else {
              this.refreshSourceDetails();
              this.targetInTransitLPN = obj.to_lpn;
              this.validateTargetLPN();
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            this.closeDialog();
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          this.closeDialog();
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
    PrinterDetails,
  },
};
